import styled from 'styled-components';
import { fontFamilyRoboto } from '../Theme/Theme.styled';

export const Wrapper = styled.section`
  font-family: ${fontFamilyRoboto};
  margin: 0 auto;
  z-index: 2;
  width: 100%;
  background-color: transparent;
`;

export const ContentTitle = styled.span`
  color: #007a64;
  font-weight: bold;
  font-size: 22px;

  @media (max-width: 520px) {
    width: 100%;
    display: flex;
  }
`;

export const Comma = styled.span`
  @media (max-width: 520px) {
    display: none;
  }
`;

export const Content = styled.section`
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  line-height: 24px;
  margin-bottom: 15px;
  font-size: 16px;
  padding: 20px 20px;
  color: #333;
  box-sizing: border-box;
  word-wrap: break-word;

  @media (max-width: 800px) {
    margin: 33% auto 0px;
  }
`;

export const SubText = styled.section`
  font-size: 14px !important;
  font-family: ${fontFamilyRoboto};
  margin: 0 auto;
  width: fit-content;
`;

export const ContentText = styled.section`
  margin-top: 50px;
  font-size: 20px;
`;

export const LoaderImageWrapper = styled.section`
  margin: 0 auto;
  width: fit-content;
`;

export const LoaderImage = styled.img`
  width: 300px;
  image-rendering: auto;
`;
